import api, { adminApiPrefix } from './Api';
import {
  Page,
  pageFromResponse,
  pageToUpsertRequest,
} from '../interfaces/Page/Page';

const pageAdminApiPrefix = `${adminApiPrefix}/page`;

export const createPage = async (page: Page): Promise<Page> => {
  const response = await api.post(
    pageAdminApiPrefix,
    pageToUpsertRequest(page),
  );

  return pageFromResponse(response.data?.data);
};

export const getPages = async (): Promise<Page[]> => {
  const response = await api.get(pageAdminApiPrefix);

  return (response.data?.data ?? []).map((page: any) => pageFromResponse(page));
};

export const getPage = async (slug: string): Promise<Page> => {
  const response = await api.get(`${pageAdminApiPrefix}/${slug}`);

  return pageFromResponse(response.data?.data);
};

export const updatePage = async (page: Page): Promise<Page> => {
  const response = await api.put(
    `${pageAdminApiPrefix}/${page.id}`,
    pageToUpsertRequest(page),
  );

  return pageFromResponse(response.data?.data);
};

export const deletePage = async (id: number): Promise<void> =>
  api.delete(`${pageAdminApiPrefix}/${id}`);
